module.exports = __webpack_public_path__ + "static/media/icon_person_circle.ed9a3d0b.svg";